<template>
    <div class="main-footer">
        <div class="f_nbg">
            <ul class="f_nav clearfix">
                <!-- <li class="code doc-code">
                    <img
                        src="../../../assets/img/mainPage/doc_code.png"
                        alt="二维码"
                    />
                    <p>产品宣传册</p>
                </li> -->
                <li>
                    <b><a @click="jumpPage('/home')">网站首页</a></b>
                </li>
                <li>
                    <b><a>产品中心</a></b>
                    <p><a @click="jumpPage('/product/1')">设备监控系统(FMCS)</a></p>
                    <p><a @click="jumpPage('/product/2')">园区及企业数字化系统</a></p>
                    <p><a @click="jumpPage('/product/3')">节能减排与能源管理</a></p>
                    <p><a @click="jumpPage('/product/4')">工业机器人系统集成</a></p>
                    <p><a @click="jumpPage('/product/5')">机电安装</a></p>
                    <p><a @click="jumpPage('/product/6')">建筑智能化系统</a></p>
                </li>
                <li>
                    <b><a>精品案例</a></b>
                    <p><a @click="jumpPage('/case/1')">半导体</a></p>
                    <p><a @click="jumpPage('/case/2')">智能制造</a></p>
                    <p><a @click="jumpPage('/case/3')">医药</a></p>
                    <p><a @click="jumpPage('/case/4')">商业</a></p>
                    <p><a @click="jumpPage('/case/5')">教育</a></p>
                    <p><a @click="jumpPage('/case/6')">烟草</a></p>
                </li>
                 <li>
                    <b><a @click="jumpPage('/certificate')" >资质证书</a></b>
                    <b><a @click="jumpPage('/aboutus')" >关于我们</a></b>
                </li>
                <li class="code">
                    <img
                        src="../../../assets/img/mainPage/code.jpg"
                        alt="二维码"
                    />
                    <p>微信公众号</p>
                </li>
            </ul>
        </div>
        <ul class="contact-us">
            <li>服务热线：<a href="tel:029-68255490">029-68255490</a></li>
            <li>技术咨询：<a href="tel:029-68255491">029-68255491转816</a></li>
            <li>
                反馈邮箱：<a href="mailto:tiant@kingwings.net"
                    >tiant@kingwings.net</a
                >
            </li>
            <li>公司地址：西安市高新区锦业路绿地领海B座11201室</li>
        </ul>
        <div class="bq_bg">
            <div class="bq">
                <span>版权所有 &copy;西安锦威电子科技有限公司 </span>
                <a href="https://beian.miit.gov.cn" target="_blank" class="case-no"
                    >陕ICP备17005806号{{ caseNo }}</a
                >
                <a href="https://beian.mps.gov.cn/#/query/webSearch?code=61019002003654" rel="noreferrer" target="_blank"><img src="../../../../src//assets/img/common/beian_gongan.png"> 陕公网安备61019002003654号</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            caseNo: '',
        }
    },
    methods: {
        jumpPage(path) {
            this.$router.push(path)
        },
    },
    created() {
        let host = location.host
        // kingwings.net  陕ICP备17005806号-1
        if (host.indexOf('kingwings.net') !== -1) {
            this.caseNo = '-1'
        } else if (host.indexOf('xn--xys63ag28cqg3a.xn--kput3i') !== -1) {
            // 锦威电子.手机  陕ICP备17005806号-3 
            this.caseNo = '-3'
        } else if (host.indexOf('xn--xys63ag28cqg3a.xn--ses554g') !== -1) {
            // 锦威电子.网址  陕ICP备17005806号-2
            this.caseNo = '-2'
        }
    },
}
</script>

<style scoped lang="less">
.main-footer{
    // position: fixed;
    bottom:0;
    width:100%;
}
.f_nbg {
    width: 100%;
    // min-width: 1150px;
    background: #323232;
    margin: 0px auto;
    padding: 35px 0;
}

.f_nav {
    width: 1080px;
    height: 150px;
    margin: 0px auto;
}

.f_nav li {
    width: 165px;
    float: left;
    text-align: left;
    border-right: 1px solid #444;
    height: 150px;
    padding: 0 20px;
    &.second-li {
        border-left: 1px solid #444;
    }
}

.f_nav li:nth-of-type(2){
    width:28em;

    p{
        width:12em;
        float: left;
    }
}
.f_nav li:nth-of-type(3){
    width:20em;

    p{
        width:8em;
        float: left;
    }
}

.f_nav li b {
    display: block;
    width: 100%;
    height: 25px;
    line-height: 25px;
    margin-bottom: 15px;
    font-weight: normal;
}

.f_nav li b a {
    font-size: 16px;
    color: #fff;
    cursor: pointer;
}:hover{
    color:#48C4DC;
}

.f_nav li.noline,
.f_nav li.code {
    border: 0;
}

.f_nav li.code {
    margin-right: 0;
    float: right;
    padding: 0;
    &.doc-code {
        float: left;
        margin-right: 40px;
    }
}

.f_nav li p {
    width: 100%;
    background: url('../../../assets/img/mainPage/cirlce.jpg') no-repeat left
        center;
    line-height: 30px;
}

.f_nav li p a {
    font-size: 12px;
    color: #888;
    margin-left: 10px;
}

.f_nav li p a:hover {
    color: #fff;
}

.f_nav li.code p {
    background: none;
    height: 25px;
    line-height: 25px;
    text-align: center;
    color: #999;
    padding-top: 5px;
}

.f_nav li.code {
    width: 129px;
    height: 151px;
    padding: 8px;
    background: #4e4c4d;
}

.f_nav li.code img {
    width: 113px;
    height: 113px;
    vertical-align: top;
}

.bq_bg {
    width: 100%;
    // min-width: 1150px;
    margin: 0px auto;
    text-align: center;
    background: #1f1f1f;
    height: 60px;
}

.bq {
    // width: 1150px;
    margin: 0px auto;
    text-align: center;
    height: 60px;
}

.bq span,
.bq a {
    display: inline-block;
    *display: inline;
    zoom: 1;
    vertical-align: top;
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    color: #fff;
    margin-top: 20px;
    margin-left: 5px;
}
.bq a {
    color: #48C4DC;
}
.bq a:hover {
    color: #5599EE;
}
.bq img {
    width: 20px;
    height: 20px;
    vertical-align: top;
}
ul.contact-us {
    display: none;
}

@media (max-width: 1440px) {
    .f_nav{
        height:210px;
        padding-left: 10%;
    }
}
</style>
